/**
 * notFound.js — 404 Not Found page.
 *
 * Rendered by the catch-all Route in App.js when no other route matches.
 * Displays a 404 illustration and sets the appropriate SEO meta tags.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';

// ─── Internal — images ────────────────────────────────────────────────────────
import ImageNotFound from '../../images/404.png';

// ─── Main component ───────────────────────────────────────────────────────────

/**
 * NotFound — 404 page.
 * No props accepted.
 *
 * @returns {JSX.Element}
 */
export const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Not Found</title>
        <meta name="prerender-status-code" content="400" />
      </Helmet>
      <Container>
        <div className='text-center'>
          <img src={ImageNotFound} alt="not found" className='d-block mx-auto' />
        </div>
      </Container>
    </>
  );
};
